module.exports = "h4{\n        width: 200px;\n    overflow: hidden;\n}\n\n@media screen and (min-width: 768px) and (max-width: 778px){\n\n    .btnDiv{\n        margin-left: -21px !important;\n    }\n}\n\n@media screen and (min-width: 1024px) and (max-width: 1025px) {\n    .btnDiv {\n        margin-left: -17%;\n    }\n}\n\n@media screen and (max-width: 1024px) {\n\n/* p{\n    margin: 0 7px 10px !important;\n} */\n/* #artistsName{\n    margin-top: -15px !important;\n} */\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/songs/gridview-songs/gridview-songs.component.css
// module id = ./src/app/songs/gridview-songs/gridview-songs.component.css
// module chunks = main